import React, { useState } from 'react';
import ProposalStatusBadge from './ProposalStatusBadge';

const DecisionEngineCard = ({ check }) => {
  const [expanded, setExpanded] = useState(false);

  if (!check) return null;

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden mb-3">
      {/* Header */}
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors text-left"
      >
        <div className="flex items-center gap-3">
          <ProposalStatusBadge status={check.result} size="md" />
          <div>
            <h4 className="font-semibold text-gray-900">{check.check_name}</h4>
            <p className="text-sm text-gray-600 mt-0.5">{check.summary}</p>
          </div>
        </div>
        <svg
          className={`w-5 h-5 text-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`}
          fill="none" viewBox="0 0 24 24" stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Expanded Content */}
      {expanded && (
        <div className="border-t border-gray-200 p-4 bg-gray-50 space-y-4">
          {/* Reasoning */}
          {check.reasoning && (
            <div>
              <h5 className="text-sm font-semibold text-gray-700 mb-1">Reasoning</h5>
              <p className="text-sm text-gray-600">{check.reasoning}</p>
            </div>
          )}

          {/* Questionnaire Sources */}
          {check.questionnaire_sources && check.questionnaire_sources.length > 0 && (
            <div>
              <h5 className="text-sm font-semibold text-gray-700 mb-2">From the Conversation</h5>
              <div className="space-y-2">
                {check.questionnaire_sources.map((src, idx) => (
                  <div key={idx} className="bg-white rounded p-3 border border-gray-100">
                    <div className="flex items-start gap-2">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-50 text-blue-700">
                        {src.question_number}
                      </span>
                      <div>
                        <p className="text-sm font-medium text-gray-800">{src.question_text}</p>
                        <p className="text-sm text-primary-600 font-medium mt-0.5">"{src.response}"</p>
                        {src.relevance && (
                          <p className="text-xs text-gray-500 mt-1">{src.relevance}</p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Knowledge Base Sources */}
          {check.knowledge_base_sources && check.knowledge_base_sources.length > 0 && (
            <div>
              <h5 className="text-sm font-semibold text-gray-700 mb-2">Reference Data</h5>
              <div className="space-y-2">
                {check.knowledge_base_sources.map((src, idx) => (
                  <div key={idx} className="bg-white rounded p-3 border border-gray-100">
                    <div className="flex items-start gap-2">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-primary-50 text-primary-700">
                        {src.category}
                      </span>
                      <div>
                        <p className="text-sm font-medium text-gray-800">{src.entry_name}</p>
                        <p className="text-sm text-gray-600 mt-0.5">{src.key_data}</p>
                        {src.relevance && (
                          <p className="text-xs text-gray-500 mt-1">{src.relevance}</p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Recommendations */}
          {check.recommendations && check.recommendations.length > 0 && (
            <div>
              <h5 className="text-sm font-semibold text-gray-700 mb-1">Recommendations</h5>
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                {check.recommendations.map((rec, idx) => (
                  <li key={idx}>{rec}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DecisionEngineCard;
